<div class="reporting">
  <ng-container *ngIf="layouts$ | async as layouts; else loading">
    <div class="reporting__empty" *ngIf="!layouts?.length">
      <mat-icon class="reporting__empty__report-icon" svgIcon="heroicons_outline:document-report"></mat-icon>
      <div class="reporting__empty__prompt">
        <h2>You don't have any reports.</h2>
        <p>
          <mat-icon>lightbulb_outline</mat-icon> Start creating reports by clicking&nbsp;<a (click)="create()">here</a>.
        </p>
      </div>
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="ph-item height-100p">
      <div class="ph-col-12">
        <div class="ph-picture"></div>
        <div class="ph-row">
          <div class="ph-col-6 big"></div>
          <div class="ph-col-4 empty big"></div>
          <div class="ph-col-2 big"></div>
          <div class="ph-col-4"></div>
          <div class="ph-col-8 empty"></div>
          <div class="ph-col-6"></div>
          <div class="ph-col-6 empty"></div>
          <div class="ph-col-12"></div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
